import { Collapse } from '@mui/material';
import NestedList from './NestedList';
import SubMenuHeader from './SubMenuHeader';
import { SubMenuProps } from './types';
import { useContainsActiveRoute } from './useContainsActiveRoute';

/**
 * Acordeão clássico: o grupo abre para baixo, na própria coluna. Só serve onde
 * há largura para o rótulo — barra aberta ou dentro do painel flutuante.
 */
const SubMenuInline = (props: SubMenuProps) => {
    const { children, dense, endAdornment, handleToggle, icon, isOpen, name } = props;
    const containsActive = useContainsActiveRoute(children);

    return (
        <div>
            <SubMenuHeader
                open={isOpen}
                containsActive={containsActive}
                dense={dense}
                endAdornment={endAdornment}
                icon={icon}
                name={name}
                variant="accordion"
                onClick={handleToggle}
                aria-expanded={isOpen}
            />
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <NestedList dense={dense}>{children}</NestedList>
            </Collapse>
        </div>
    );
};

export default SubMenuInline;
